"use client";

import { c as _c } from "react/compiler-runtime";
import { UiLabelsProvider } from "@dc/ui/components/UiLabels";
import type { ReactNode } from "react";
import { useTranslatedUiLabels } from "./hooks/useTranslatedUiLabels";
export function TranslatedUiLabelsProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const t1 = useTranslatedUiLabels();
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <UiLabelsProvider labels={t1}>{children}</UiLabelsProvider>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}